import Route from './Route';

const accountsEndpoint = process.env.REACT_APP_BACKEND_ACCOUNTS;
const chartEndpoint = process.env.REACT_APP_BACKEND_CHART;
const currencyEndpoint = process.env.REACT_APP_BACKEND_CURRENCY;
const publishingEndpoint = process.env.REACT_APP_BACKEND_PUBLISHING;

export default {
    session: new Route(accountsEndpoint + '/session'),
    whoami: new Route(accountsEndpoint + '/user/whoami?context=organizations'),

    // update organization
    organization: new Route(accountsEndpoint + '/organization/:organizationId'),
    // get organizations for current user
    currentUserOrganizations: new Route(
        accountsEndpoint + '/organization-membership/own',
    ),
    // members in organization
    organizationMembers: new Route(
        accountsEndpoint + '/organization-membership/:organizationId',
    ),
    organizationMembersCreate: new Route(
        accountsEndpoint + '/organization-membership',
    ),
    // update members in organization
    organizationMembersUpdate: new Route(
        accountsEndpoint + '/organization-membership/update',
    ),
    // remove members in organization
    organizationMembersRemove: new Route(
        accountsEndpoint + '/organization-membership',
    ),
    // all buckets in organization
    bucketsAll: new Route(
        accountsEndpoint +
        '/group?organizationId=:organizationId&name=:name&orderColumn=:orderColumn',
    ),
    // paged buckets in organization
    bucketsWithPagination: new Route(
        accountsEndpoint +
        '/group?organizationId=:organizationId&name=:name&page=:page&pageSize=:pageSize&orderColumn=:orderColumn',
    ),

    // create new bucket
    bucket: new Route(accountsEndpoint + '/group'),
    // update bucket
    bucketUpdate: new Route(accountsEndpoint + '/group/:bucketId'),
    // bucket members
    bucketMembers: new Route(
        accountsEndpoint + '/group-membership?groupId=:bucketId',
    ),
    // bucket member actions (add and remove)
    bucketMember: new Route(accountsEndpoint + '/group-membership'),
    // update members in bucket
    bucketMembersUpdate: new Route(
        accountsEndpoint + '/group-membership/update',
    ),
    // buckets members action (add members to buckets)
    bucketsMembers: new Route(accountsEndpoint + '/group-membership/multiple'),

    // update identity avatar
    identity: new Route(accountsEndpoint + '/identity/:identityId/picture'),
    // update identity GA settings
    identitySettings: new Route(
        accountsEndpoint + '/identity/:identityId/settings',
    ),

    // user search
    userSearch: new Route(accountsEndpoint + '/user?email=:searchTerm'),

    // organization member invitation
    inviteMember: new Route(accountsEndpoint + '/user-invitation/organization'),
    organizationInvitations: new Route(
        accountsEndpoint +
        '/user-invitation/organization/?organizationId=:organizationId',
    ),
    deleteInvitation: new Route(accountsEndpoint + '/user-invitation'),
    resendInvitation: new Route(
        accountsEndpoint + '/user-invitation/organization/resend',
    ),

    // report
    reportCount: {
        chart: new Route(chartEndpoint + '/search/count.json'),
        currency: new Route(currencyEndpoint + '/search/count'),
        survey: new Route(publishingEndpoint + '/survey/project/count'),
        mapspice: new Route(publishingEndpoint + '/mapspice/project/count'),
        layout: new Route(publishingEndpoint + '/layout/project/count'),
    },
    tags: {
        search: new Route(chartEndpoint + '/search/tag'),
    },
    assets: {
        chart: {
            create: new Route(
                chartEndpoint + '/project/create-from-definition',
            ),
            search: new Route(chartEndpoint + '/search/project.json'),
            update: new Route(chartEndpoint + '/project/:chartId'),
            bulkClone: new Route(chartEndpoint + '/bulk/project/clone'),
            bulkMove: new Route(
                chartEndpoint + '/bulk/project/transfer-ownership',
            ),
            softDelete: new Route(
                chartEndpoint + '/project/:chartId/soft-delete',
            ),
            hardDelete: new Route(
                chartEndpoint + '/project/:chartId/hard-delete',
            ),
            publish: new Route(chartEndpoint + '/project/:chartId/publish'),
            publishProjectTablesToImage: {
                getPath: ({ projectId }) =>
                    chartEndpoint + `/project/${projectId}/export-projects-to-image`,
            },
        },
        currency: {
            create: new Route(currencyEndpoint + '/project'),
            search: new Route(currencyEndpoint + '/search/project'),
            update: new Route(currencyEndpoint + '/project/:currencyId'),
            bulkClone: new Route(currencyEndpoint + '/bulk/project/clone'),
            bulkMove: new Route(
                currencyEndpoint + '/bulk/project/transfer-ownership',
            ),
            bulkDelete: new Route(currencyEndpoint + '/bulk/project/delete'),
            publish: new Route(currencyEndpoint + '/project/:currencyId/publish'),
        },
        survey: {
            project: new Route(publishingEndpoint + '/survey/project'),
            update: new Route(publishingEndpoint + '/survey/project/:surveyId'),
            clone: new Route(
                publishingEndpoint + '/survey/project/:surveyId/clone',
            ),
            delete: new Route(publishingEndpoint + '/survey/project/:surveyId'),
            publish: new Route(publishingEndpoint + '/survey/project/:surveyId/publish'),
        },
        mapspice: {
            project: new Route(publishingEndpoint + '/mapspice/project'),
            update: new Route(publishingEndpoint + '/mapspice/project/:mapId'),
            clone: new Route(
                publishingEndpoint + '/mapspice/project/:mapId/clone',
            ),
            delete: new Route(publishingEndpoint + '/mapspice/project/:mapId'),
            publish: new Route(publishingEndpoint + '/mapspice/project/:mapId/publish'),
        },
        layout: {
            project: new Route(publishingEndpoint + '/layout/project'),
            update: new Route(publishingEndpoint + '/layout/project/:layoutId'),
            clone: new Route(
                publishingEndpoint + '/layout/project/:layoutId/clone',
            ),
            delete: new Route(publishingEndpoint + '/layout/project/:layoutId'),
            publish: new Route(publishingEndpoint + '/layout/project/:layoutId/publish'),
        },
    },
};



// WEBPACK FOOTER //
// ./src/helpers/BackendPaths.js